import React, { useState } from 'react'
import {
    Drawer,
    DrawerContent,
    DrawerItem,
    DrawerItemProps,
    DrawerSelectEvent,
} from "@progress/kendo-react-layout";
import Chat from './Chat';
import { ChatApi } from '../redux/api/ChatApi';
import { Route, Routes, useNavigate, useParams } from 'react-router-dom';
import { Button } from "@progress/kendo-react-buttons";
import "./Chat.scss"
import { useReduxDispatch } from '../redux/hooks';
import { ChatListItem } from './ChatListItem';
import { IChat } from '../types/IChat';
import ChatFilter, { FilterProps } from './ChatFilter';
import ChatList from './ChatList';

export default function ChatPage() {
    const navigate = useNavigate()
    const { id } = useParams()
    const dispatch = useReduxDispatch();
    //const storage = useReduxSelector(s => s.chat.chats);
    const [expanded, setExpanded] = React.useState(true);
    const { data: chats } = ChatApi.useGetChatsQuery();
    const { data: userProfile } = ChatApi.useGetProfileQuery();
    const [filter, setFilter] = useState<FilterProps>({} as FilterProps)

    //Sort by last message date
    const renderItems = chats?.slice().sort((c, c2) => {
        return (new Date(c2?.Last_Message_Date).getTime() - new Date(c?.Last_Message_Date).getTime())
    }
    ).filter(c => c).map(c => {
        return c ? {
            chat: c,
            unread: new Date(c?.Last_Message_Date).getTime() >= new Date(c?.Staff_Last_Read).getTime(),
            selected: c?.ConversationId === id,
            menu: false,
            text: c?.End_User,
            route: `/chat/${c.ConversationId}`,
            subtext: `${c?.Last_Message_Contact_Id == userProfile?.Id ? 'You' : c?.Last_Message_By}: ${c.Last_Message}`,
            last: c?.Last_Message_Date,
            image: c?.EndUser_Profile_Path
        } : {} as RenderProps
    })

    const CustomItem = (props: DrawerItemProps) => {
        return (
            <DrawerItem {...props} className={props.unread == true ? 'unread chat-item' : 'chat-item'}>
                {props.menu == true ?
                    <>
                        <Button icon="menu" fillMode="flat" onClick={() => setExpanded((currentVal) => !currentVal)} style={{ marginLeft: 21, marginRight: 21 }} />
                        <div><ChatFilter onFilterChange={(val) => setFilter(val)} /></div>
                    </>
                    : <ChatListItem {...props.chat} />
                }
            </DrawerItem>
        );
    };

    const NewItem = (props: DrawerItemProps) => {
        return (
            <DrawerItem {...props} >
                {/* className={props.unread == true ? 'unread chat-item' : 'chat-item'}> */}
                <ChatList chatClicked={(chatId) => navigate(`/chat/${chatId}`)} showHeader={true} toggleExpanded={() => setExpanded(prev => !prev)} />
            </DrawerItem>
        );
    };

    const onSelect = (e: DrawerSelectEvent) => {
        //history.push(e.itemTarget.props.route);
        //navigate(e.itemTarget.props.route);
        //setExpanded(!expanded);
    };

    //add drawer menu
    renderItems?.unshift({ menu: true } as RenderProps)

    const style = `linear-gradient(to bottom, ${userProfile?.Nav_Hex_Color}, #ffffff)` // `linear-gradient(0deg, ${userProfile?.Nav_Hex_Color} 0%,#ffffff 100%)!important;`
    return (
        <div style={{ backgroundImage: style }} className='chat-fullscreen grow flex-col'>
            {/* <div className='k-drawer-wrapper'>
                {userProfile?.Features.Chat &&
                    <div className={expanded ? 'sidebar k-drawer k-drawer-end' : 'sidebar sidebar-collapsed k-drawer k-drawer-end'}>
                        <Scrollbars autoHeight={false}>
                            <ChatNotification pinChatOnClick={false} />
                            <ChatList chatClicked={(chatId) => navigate(`/chat/${chatId}`)} showHeader={true} toggleExpanded={() => setExpanded(prev => !prev)} />
                        </Scrollbars>
                    </div>}
                <div className='k-drawer-content'>
                    <Routes>
                        <Route path="/chat/:id" element={<Chat showHeader={true} showOptions={true} />} />
                        <Route path="*" element={<Chat showHeader={true} showOptions={true} />} />
                    </Routes></div>
            </div> */}
            {userProfile?.Features.Chat ?
                <Drawer
                    expanded={expanded}
                    position={"end"}
                    mode={"push"}
                    mini={true}
                    item={NewItem}
                    items={[{}]}
                    onSelect={onSelect}
                    width={350}
                    miniWidth={60}
                    style={{ transition: 'none' }}
                >
                    <DrawerContent>
                        <Routes>
                            <Route path="/chat" element={<Chat />} />
                            <Route path="/chat/:id/*" element={<Chat showHeader={true} />} />
                            <Route path="*" element={<Chat showHeader={true} />} />
                        </Routes>
                    </DrawerContent>
                </Drawer>
                : <Chat showHeader={true} />}
        </div>
    )
}

export type RenderProps = {
    unread: boolean,
    selected: boolean,
    menu: boolean,
    text: string,
    route: string,
    chat: IChat
}